export const MODE_SOURCE = {
    DASHBOARD: "fromDashboard",
    SALES_AND_PROMOTION: "fromSalesAndPromotion",
    SETTINGS: "fromSettings",
};

export const getPreviewUrl = (file) => {
    if (!file) return null;
    if (file.url) return file.url;
    if (file instanceof File) return URL.createObjectURL(file);
    return null;
};
